import { useMemo } from 'react'

import CategorySection from '@/components/molecules/CategorySection'
import { useHubStore } from '@/stores/HubStore'
import { sortAscByOrder } from '@/util/sortOrder'

function Categories() {
  const hubs = useHubStore(store => store.hubs)
  // ? It's safe to assume that every hub will have the same categories
  const categories = useMemo(() => hubs[0]?.categories, [hubs])

  return categories && categories
    .sort(sortAscByOrder)
    .map(category => (
      <CategorySection key={category.id} category={category} />
    ))
}

export default Categories
